// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__T4Xba","active":"downloadDropdown_active__1beDJ"};